import type { Quote } from '../../../types/quotes/quote'

export const getDepositInvoiceDetailsModalProps = (quote: Quote | undefined) => ({
  quoteCurrency: quote?.summary.foreignCurrency ?? 'EUR',
  quoteLocale: quote?.locale,
  quoteAmount: quote?.summary.foreignNetTotal ?? 0,
  quoteLines: quote?.lines || [],
})
